module.exports = __webpack_public_path__ + "static/img/news_pic.5ebd05bb.png";